__webpack_require__.p = "/functions-of-money/";